<template>
<div :class="['drawer', { open: isDrawerOpen, 'screen-lg': onTabletUp }]" :style="setDrawerHeight()" ref="drawerWrapper">
  <div
    :class="{
      drawerContentStack: true,
      visible: i <= activeNavIndex ? true : false,
    }"
    v-for="(content, i) in navContent"
  >
    <div class="drawer-header" ref="drawerHeader">
      <h3 class="drawer-title" @click="goBack">
        <span v-if="activeNavIndex > 0 || hasNavHistory(content)">
          <BaseIcon name="chevron-left" v-if="loggedIn && isDrawerOpen && content.title" />
        </span>
        {{ content.langTitle || $t('drawer.kitchenDrawer') }}
      </h3>
      <BaseButton
        v-if="content.langTitle === $t('lblGroceryList')"
        type="button"
        :class="['btn-small', { 'btn-clear': isDrawerOpen }]"
        @click="showModalToggle"
      >
        <i class="fas fa-share-alt"></i>
        <span v-if="loggedIn && isDrawerOpen && content.langTitle === $t('lblGroceryList') && !onTabletUp">{{ $t(' Share') }}</span>
      </BaseButton>
      <BaseButton type="button" :class="['btn-small', { 'btn-clear': isDrawerOpen }]" @click="handleToggleDrawer">
        <span v-if="loggedIn && isDrawerOpen && !onTabletUp">{{ $t('lblClose') }}</span>
        <span v-if="!isDrawerOpen && !onTabletUp">{{ $t('lblOpen') }}</span>
        <span v-if="loggedIn && isDrawerOpen && onTabletUp" @click.stop="handleCloseDesktop">{{ $t('lblClose') }}</span>
      </BaseButton>
    </div>
    <div class="drawer-content" ref="drawerContent">
      <hr v-if="content.component" />
      <component
        :is="content.component || 'KitchenDrawerNav'"
        :isEmbed="embed"
        :onTabletUp="onTabletUp"
        :data="content.data"
        :deepLink="content.deepLink"
        @drawerComponentDataChanged="onComponentDataChanged"
      />
    </div>
  </div>
</div>
</template>

<script>
import _ from 'lodash';
import store from '@state/store';
import DietOptions from '../DietOptions/DietOptions';
import HealthOptions from '../HealthOptions/HealthOptions';
import { shareMixin } from 'shareMixin';
import GoShopping from '../GroceryList/GoShopping';
import GroceryList from '../GroceryList/GroceryList';
import KitchenDrawerNav from './KitchenDrawerNav';
import Favorites from '../Favorites/Favorites';
import Plans from '../Plans/Plans';
import PlanDetail from '../Plans/PlanDetail';
import PlanDetailPublic from '../Plans/PlanDetailPublic';
import PlanSummary from '../Plans/PlanSummary';
import PlanLeftoverOptions from '../Plans/PlanLeftoverOptions';
import Recipes from '../Recipes/Recipes';
import RecipeDetail from '../RecipeDetail/RecipeDetail';
import RecipeDetailPublic from '../RecipeDetail/RecipeDetailPublic';
import MealDetail from '../MealDetail/MealDetail';
import MacroWizard from '../macroWizard/macro-wizard';
import MacroStepOne from '../macroWizard/macro-step-one';
import MacroStepTwo from '../macroWizard/macro-step-two';
import MacroStepThree from '../macroWizard/macro-step-three';
import MacroStepFour from '../macroWizard/macro-step-four';
import Settings from '../Settings/Settings';
import {
  authComputed,
  dishesMethods,
  groceryListMethods,
  kitchenDrawerComputed,
  kitchenDrawerMethods,
  planMethods,
  primaryNavComputed,
  recipesMethods,
} from '@state/helpers';

export default {
  mixins: [shareMixin],
  components: {
    DietOptions,
    GoShopping,
    GroceryList,
    HealthOptions,
    KitchenDrawerNav,
    MealDetail,
    Plans,
    PlanDetail,
    PlanDetailPublic,
    PlanSummary,
    PlanLeftoverOptions,
    Recipes,
    Favorites,
    RecipeDetail,
    RecipeDetailPublic,
    MacroWizard,
    MacroStepOne,
    MacroStepTwo,
    MacroStepThree,
    MacroStepFour,
    Settings,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      drawerHeight: null,
      embed: true,
    };
  },
  computed: {
    ...authComputed,
    ...kitchenDrawerComputed,
    ...primaryNavComputed,
    currentView() {
      return this.navContent[this.activeNavIndex];
    },
    currentPrimaryView() {
      return this.primaryNavContent[this.activePrimaryNavIndex];
    },
    isDrawerOpen() {
      return this.isOpen;
    },
    showFullPageOpt() {
      const currentComponent = this.currentView.component;
      return currentComponent === 'RecipeDetail' || currentComponent === 'MealDetail';
    },
    disableBackBtn() {
      switch (this.currentPrimaryView.component) {
        case 'Recipes':
          return true;
        default:
          return false;
      }
    },
  },
  mounted() {
    // if (this.onTabletUp) {
    //   setTimeout(() => {
    //     if (!this.$refs.drawerWrapper){
    //       console.log('this.$refs.drawerWrapper: ', this.$refs.drawerWrapper)
    //     }
    //     // this.$refs.drawerWrapper.style.background = 'rgba(255, 255, 255, 0.75)';
    //   }, 299);
    // }
  },
  methods: {
    ...dishesMethods,
    ...groceryListMethods,
    ...kitchenDrawerMethods,
    ...planMethods,
    ...recipesMethods,
    setDrawerHeight() {
      if (!this.onTabletUp) {
        const wh = window.innerHeight;
        let dh;

        if ((this.isDrawerOpen && this.currentView && this.currentView.title === 'Kitchen Drawer') || (this.isDrawerOpen && this.currentView.title === null)) {
          dh = `${wh - wh + (7 * (3 + 1) + 3)}rem`;
        } else if (this.isDrawerOpen && this.currentView.title !== 'Kitchen Drawer') {
          dh = `${(wh - 20) / 10}rem`;
        } else {
          dh = `${(wh - wh + 59) / 10}rem`;
        }

        return {
          height: dh,
        };
      }
    },
    calcDrawerHeight() {
      const headerHeight = this.$refs.drawerHeader[this.activeNavIndex].clientHeight;
      const contentHeight = this.$refs.drawerContent[this.activeNavIndex].clientHeight;
      this.drawerHeight = Math.floor(100 - headerHeight + contentHeight / window.innerHeight);
    },
    isBackBtnDisabled() {
      switch (this.currentPrimaryView.component) {
        case 'Recipes':
          return true;
        default:
          return false;
      }
    },
    goBack() {
      if (this.loggedIn) {
        if (this.navContent.length === 1 && this.navContent[0] && this.hasNavHistory(this.navContent[0])) {
          this.setSelectedDaySlot(null);
          this.resetDrawer();
          this.calcDrawerHeight();
        } else {
          this.navigateHigher();
          this.calcDrawerHeight();
        }

        if (this.navContent.length && this.navContent[this.navContent.length - 1].title === 'Add Recipe') {
          this.setDishToAdd(null);
          this.setDailySummary(null);
        }
      }
    },
    hasNavHistory(content) {
      return content.title !== 'Kitchen Drawer' ? true : false;
    },
    refreshPlanGrid() {
      this.getCurrentPlanGrid().finally(() => {
        if (this.onTabletUp === undefined || this.onTabletUp) {
          return this.getGroceryList();
        }
      });
    },
    clearDishFilters() {
      this.setDishes([]);
      this.initializeFilterQueryString();
      this.getDishes();
    },
    showModalToggle() {
      this.setShowModal();
    },
    handleToggleDrawer() {
      if (this.onTabletUp) {
        this.setRecipeDetailFull({ ...this.currentView.data });
        this.refreshPlanGrid();
      } else {
        this.toggleDrawer();
        this.setDishToAdd(null);
        this.setSelectedDaySlot(null);
      }

      if (this.currentView.component === 'Recipes') {
        this.clearDishFilters();
      }
    },
    handleCloseDesktop() {
      this.refreshPlanGrid();
      this.toggleDrawer();
      this.setDishToAdd(null);
      this.setDailySummary(null);
      this.setSelectedDaySlot(null);
      if (this.currentPrimaryView.component === 'Plans') {
        this.updateShareableUrl(this.currentPrimaryView.component);
      }
    },
    onComponentDataChanged(newData) {
      // update the currentViews data...
      // 1) spread the old data out into a new object
      // 2) spread the newData and let it overwrite any props that need to be updated.
      this.currentView.data = {
        ...this.currentView.data,
        ...newData,
      };
    },
  },
  watch: {
    isDrawerOpen() {
      this.calcDrawerHeight();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.drawer {
  background: $color-kitchen-drawer-bg;
  border-top: 1px solid $color-kitchen-drawer-border;
  border-top-left-radius: $base-border-radius + 1.5;
  border-top-right-radius: $base-border-radius + 1.5;
  bottom: 0;
  position: fixed;
  transition: height ease-in-out $duration-kitchen-drawer;
  width: 100%;
  z-index: 9998;

  .drawerContentStack {
    border-top-left-radius: $base-border-radius + 1.5;
    border-top-right-radius: $base-border-radius + 1.5;
    display: block;
    height: 100vh;
    left: 100vw;
    position: absolute;
    transition: left ease-in-out $duration-kitchen-drawer;
    width: 100vw;

    &.visible {
      left: 0;
    }
  }

  .drawer-header {
    align-items: center;
    background: $color-kitchen-drawer-bg;
    border-radius: 3rem;
    display: flex;
    justify-content: space-between;
    padding: 1.4rem 2rem 0.2rem;

    .drawer-title {
      font-family: $brand-font-family;
      margin-bottom: 0;
    }

    svg {
      margin-right: 1rem;
    }

    .btn-clear {
      background-color: transparent;
      border: 0;
      color: $color-kitchen-drawer-btn-clear-text;
      font-size: 1.4rem;
      font-weight: 600;
      text-transform: uppercase;
    }

    .btn-small {
      margin: 0;
    }
  }

  &.open {
    background-color: $color-kitchen-drawer-bg-open;
    border-color: $color-kitchen-drawer-bg-border-open;
    border-top-left-radius: $base-border-radius + 1.5;
    border-top-right-radius: $base-border-radius + 1.5;
    box-shadow: $color-kitchen-drawer-shadow;

    .drawerContentStack {
      background-color: $color-kitchen-drawer-bg-open;
      z-index: 10;

      .drawer-header {
        background: transparent;
      }
    }
  }

  .drawer-content {
    overflow-y: scroll;

    hr {
      margin-bottom: 0;
      width: 95%;
    }
  }

  &.screen-lg {
    align-items: center;
    -webkit-backdrop-filter: blur(4px);
    background: transparent;
    border-top: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    left: 0;
    margin: 0 auto;
    position: absolute;
    right: 0;
    top: 0;
    -webkit-transition: height ease-in-out 400ms;
    transition: height ease-in-out 400ms, background ease-in-out 150ms;
    width: 100%;
    z-index: 9998;

    .drawerContentStack {
      border-radius: 2.5rem;
      display: block;
      height: 75%;
      left: unset;
      position: absolute;
      -webkit-transition: left ease-in-out 400ms;
      transition: left ease-in-out 400ms;
      width: 37.5rem;

      // iPad up
      @include media('xl', null) {
        top: 7vh;
      }

      // iPad Pro up
      @include media('xxl', null) {
        top: 8vh;
      }

      &:last-child {
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
      }
    }

    /deep/.filters-in-modal {
      display: none;
    }

    /deep/.recipe-items-wrapper.filters-in-modal {
      display: block;
    }

    div[deeplink] {
      /deep/.plans {
        background-color: $color-kitchen-drawer-bg-open;
        border-bottom-left-radius: 2.5rem;
        border-bottom-right-radius: 2.5rem;
        box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.3);
      }
    }
  }
}
</style>
